import { getAccountsFileDownloadRanking } from 'api';
import Pagination from 'components/Pagination';
import { defaultPageSizeOptions } from 'constant/Pagination/pageSizeOption';
import useErrorNetworkMessage from 'hook/useErrorNetworkMessage';
import useCustomQuery from 'hook/useQuery/useCustomQuery';
import { useEffect, useState } from 'react';
import AccountsFileDownloadRankingTable from './AccountsFileDownloadRankingTable';
import { TableStyle } from './LayoutDefault/styled';

const AccountsFileDownloadRanking = ({
  filterData,
  pageSize,
  countToReset,
  setIsAccountsTableLoading,
  emptyText
}) => {
  const { useQueryAPI } = useCustomQuery();
  const { isOnline, errorNetWork } = useErrorNetworkMessage();

  const [pageNumber, setPageNumber] = useState(1);

  const { data: accountsFileDownloadRankingList = [], isLoading } = useQueryAPI(
    {
      api: getAccountsFileDownloadRanking,
      key: ['getAccountsFileDownloadRankingList', countToReset],
      params: {
        pageNumber,
        pageSize,
        dateFrom: filterData.dateFrom.format('YYYY-MM-DD'),
        dateTo: filterData.dateTo.format('YYYY-MM-DD'),
        filterId: filterData?.productId,
      },
    },
  );

  useEffect(() => {
    setPageNumber(1);
  }, [countToReset, pageSize]);

  
  useEffect(() => {
    setIsAccountsTableLoading(isLoading);
  }, [isLoading]);
  
  const handleChangePageNumber = (pageNumber) => {
    if (isOnline) {
      setPageNumber(pageNumber);
    } else {
      errorNetWork();
    }
  };

  return (
    <TableStyle>
      <AccountsFileDownloadRankingTable
        dataRaw={accountsFileDownloadRankingList?.data}
        isLoading={isLoading}
        emptyText={isLoading ? '集計中です。' : emptyText}
      />

      <Pagination
        currentPage={pageNumber}
        handlePagingChange={handleChangePageNumber}
        total={accountsFileDownloadRankingList?.data?.total}
        pageSize={pageSize}
        pageSizeOptions={defaultPageSizeOptions}
        isShowTotal={false}
      />
    </TableStyle>
  );
};

export default AccountsFileDownloadRanking;
